// Two-note ascending chime for high-priority signals (e.g., new leads).
// Uses the Web Audio API so we don't have to ship any external audio
// asset and zero CDN/asset routing concerns.

let _ctx = null;

const getCtx = () => {
  if (typeof window === 'undefined') return null;
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  if (!_ctx) {
    try { _ctx = new Ctor(); } catch { return null; }
  }
  return _ctx;
};

const playTone = (ctx, freq, startAt, duration, gainPeak) => {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.setValueAtTime(freq, startAt);

  // Quick attack + soft decay → pleasant bell-like envelope
  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(gainPeak, startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);

  osc.connect(gain).connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + duration + 0.02);
};

/**
 * Play a two-note ascending chime (C5 → E5).
 * Safe to call without user interaction guard — autoplay-blocked browsers
 * will silently fail and we don't throw.
 */
export const playNewLeadChime = () => {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    // Resume in case the context was suspended (autoplay policy)
    if (ctx.state === 'suspended') {
      try { ctx.resume(); } catch { /* ignore */ }
    }
    const now = ctx.currentTime;
    // C5 = 523.25 Hz, E5 = 659.25 Hz
    playTone(ctx, 523.25, now,        0.28, 0.18);
    playTone(ctx, 659.25, now + 0.16, 0.42, 0.22);
  } catch {
    /* silent — never block the toast on audio failure */
  }
};
